import * as access from './access'
import * as ticket from './ticket'
import * as troubleshooting from './troubleshooting'
import * as users from './users'
import * as core from './core'

module.exports = {
  ...core,
  ...access,
  ...ticket,
  ...troubleshooting,
  ...users
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/index.js